module.exports = __webpack_public_path__ + "static/img/game_ctl.ecb32ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prj/game_ctl.jpg
// module id = 468Z
// module chunks = 1